const PROCESSING_FACTORY_FIELD_LABELS = {
  code: '代號',
  name: '名稱',
  chineseName: '中文名',
  englishName: '英文名',
  taxIdNumber: '統編',
  homepage: '網址',
  phone: '電話',
  fax: '傳真',
  warehouseIds: '工作倉',
  remark: '備註',
  addresses: '地址',
  contacts: '聯絡人',
};

function resolveProcessingFactoryFieldLabel(path) {
  const addressMatch = path.match(/^addresses\.(\d+)\.(.+)$/);
  if (addressMatch) {
    const index = Number(addressMatch[1]) + 1;
    const field = addressMatch[2];
    const fieldLabels = {
      addressType: '類型',
      postalCode: '郵遞區號',
      city: '縣市',
      district: '行政區',
      address: '地址',
      isDefault: '預設',
      remark: '備註',
    };
    return `地址 #${index} ${fieldLabels[field] || field}`;
  }

  const contactMatch = path.match(/^contacts\.(\d+)\.(.+)$/);
  if (contactMatch) {
    const index = Number(contactMatch[1]) + 1;
    const field = contactMatch[2];
    const fieldLabels = {
      name: '姓名',
      department: '部門',
      title: '職稱',
      phone: '電話',
      mobile: '手機',
      email: 'Email',
      isDefault: '預設',
      remark: '備註',
    };
    return `聯絡人 #${index} ${fieldLabels[field] || field}`;
  }

  return undefined;
}

export {
  PROCESSING_FACTORY_FIELD_LABELS,
  resolveProcessingFactoryFieldLabel,
};
